var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScribeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7075 5.2925L16.7075 0.2925C16.6146 0.199666 16.5042 0.126052 16.3829 0.0758639C16.2615 0.0256758 16.1314 -0.000102986 16 3.09198e-07H6C5.46957 3.09198e-07 4.96086 0.210714 4.58579 0.585787C4.21071 0.960859 4 1.46957 4 2V4H2C1.46957 4 0.960859 4.21071 0.585786 4.58579C0.210714 4.96086 0 5.46957 0 6V24C0 24.5304 0.210714 25.0391 0.585786 25.4142C0.960859 25.7893 1.46957 26 2 26H16C16.5304 26 17.0391 25.7893 17.4142 25.4142C17.7893 25.0391 18 24.5304 18 24V22H20C20.5304 22 21.0391 21.7893 21.4142 21.4142C21.7893 21.0391 22 20.5304 22 20V6C22.0001 5.86864 21.9743 5.73855 21.9241 5.61715C21.8739 5.49576 21.8003 5.38544 21.7075 5.2925ZM16 24H2V6H11.5863L16 10.4137V20.98C16 20.9875 16 20.9937 16 21C16 21.0063 16 21.0125 16 21.02V24ZM20 20H18V10C18.0001 9.86864 17.9743 9.73855 17.9241 9.61715C17.8739 9.49576 17.8003 9.38544 17.7075 9.2925L12.7075 4.2925C12.6146 4.19967 12.5042 4.12605 12.3829 4.07586C12.2615 4.02568 12.1314 3.9999 12 4H6V2H15.5863L20 6.41375V20ZM13 16C13 16.2652 12.8946 16.5196 12.7071 16.7071C12.5196 16.8946 12.2652 17 12 17H6C5.73478 17 5.48043 16.8946 5.29289 16.7071C5.10536 16.5196 5 16.2652 5 16C5 15.7348 5.10536 15.4804 5.29289 15.2929C5.48043 15.1054 5.73478 15 6 15H12C12.2652 15 12.5196 15.1054 12.7071 15.2929C12.8946 15.4804 13 15.7348 13 16ZM13 20C13 20.2652 12.8946 20.5196 12.7071 20.7071C12.5196 20.8946 12.2652 21 12 21H6C5.73478 21 5.48043 20.8946 5.29289 20.7071C5.10536 20.5196 5 20.2652 5 20C5 19.7348 5.10536 19.4804 5.29289 19.2929C5.48043 19.1054 5.73478 19 6 19H12C12.2652 19 12.5196 19.1054 12.7071 19.2929C12.8946 19.4804 13 19.7348 13 20Z",
    fill: "url(#paint0_linear_383_9000)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_383_9000",
    x1: 3.71367e-8,
    y1: 26,
    x2: 25.6414,
    y2: 4.30345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A03291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7C66"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScribeIcon);
export default __webpack_public_path__ + "static/media/scribe-icon.e9c53901edd0cc236c3557a78cfa6c70.svg";
export { ForwardRef as ReactComponent };